import { HttpClient } from '../httpClient';
import MessagesResponse from '../responses/messagesResponse';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import NewMessageRequest from '../requests/newMessageRequest';
import ReplyMessageRequest from '../requests/replyMessageRequest';
import CaseloadRejectionMessage from '../models/caseloadRejectionMessage';
import { encode } from './hashidService';

const httpClient = new HttpClient();

export const getMessages = async () => {
  return httpClient.get<MessagesResponse>({
    url: '/v1/messages',
    requiresToken: true,
  });
};

export const getThread = async (messageId: number) => {
  var encrypted = encode(messageId);
  return httpClient.get<MessagesResponse>({
    url: `/v1/messages/${encrypted}`,
    requiresToken: true,
  });
};

export const updateThread = async (messageId: number) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/messages/${messageId}`,
    requiresToken: true,
  });
};
export const markAsRead = async (messageId: number) => updateThread(messageId);

export const createMessage = async (message: NewMessageRequest) => {
  return httpClient.post<MessagesResponse>({
    url: '/v1/messages',
    payload: message,
    requiresToken: true,
  });
};

export const replyToThread = async (message: ReplyMessageRequest) => {
  return httpClient.post<MessagesResponse>({
    url: '/v1/messages/reply',
    payload: message,
    requiresToken: true,
  });
};

export const getUnreadMessages = async () => {
  return httpClient.get<MessagesResponse>({
    url: '/v1/messages/unread',
    requiresToken: true,
  });
};

export const getRejectedCaseloadMessagesByTherapistUser = async (userId: number) => {
  return httpClient.get<DataResponse<CaseloadRejectionMessage[]>>({
    url: `/v1/Messages/CaseloadsByUser/${userId}/Rejected/`,
    requiresToken: true,
  });
};